<template>
  <div class="store-list">
    <v-list three-line>
      <v-list-item
        v-for="store in stores"
        :key="store._id"
        @click="$navigateTo('Store', { storeId: store._id })"
      >
        <v-list-item-avatar>
          <v-img v-if="store.avatar" v-bind:src="store.avatar" />
          <v-avatar v-else color="grey" size="40">
            <span class="white--text headline">{{
              store.name.charAt(0).toUpperCase()
            }}</span>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ store.name }}</v-list-item-title>
          <v-list-item-subtitle>{{ store.categoryName }}</v-list-item-subtitle>
          <v-list-item-subtitle>
            {{ store.location.street }} {{ store.location.houseNumber }},
            {{ store.location.zipCode }}
            {{ store.location.city }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "StoreList",

  props: ["stores"]
};
</script>
